import { Action } from '@ngrx/store';
import { HttpError, Locale } from '@rd/types';

export enum LocaleActionTypes {
  LOAD_LOCALE = '[Locale] Load Locale',
  LOAD_LOCALE_FAIL = '[Locale] Load Locale Fail',
  LOAD_LOCALE_SUCCESS = '[Locale] Load Locale Success',
  CHANGE_LOCALE = '[Locale] Change Locale',
  CHANGE_LOCALE_FAIL = '[Locale] Change Locale Fail',
  CHANGE_LOCALE_SUCCESS = '[Locale] Change Locale Success',
}

// This is to update translations
export class LoadLocale implements Action {
  readonly type = LocaleActionTypes.LOAD_LOCALE;

  constructor(public payload: Locale) {}
}

export class LoadLocaleSuccess implements Action {
  readonly type = LocaleActionTypes.LOAD_LOCALE_SUCCESS;

  constructor(public payload: Locale) {}
}

export class LoadLocaleFail implements Action {
  readonly type = LocaleActionTypes.LOAD_LOCALE_FAIL;

  constructor(public payload: HttpError) {}
}

export class ChangeLocale implements Action {
  readonly type = LocaleActionTypes.CHANGE_LOCALE;

  constructor(public payload: Locale) {}
}

export class ChangeLocaleSuccess implements Action {
  readonly type = LocaleActionTypes.CHANGE_LOCALE_SUCCESS;

  constructor(public payload: Locale) {}
}

export class ChangeLocaleFail implements Action {
  readonly type = LocaleActionTypes.CHANGE_LOCALE_FAIL;

  constructor(public payload: HttpError) {}
}

export type LocaleActions =
  | ChangeLocale
  | ChangeLocaleSuccess
  | ChangeLocaleFail
  | LoadLocaleSuccess
  | LoadLocale
  | LoadLocaleFail;
